export const PanelPaths = {
    root: 'panel',
    children: {
        dashboard: {
            path: 'dashboard'
        },
        profile: {
            path: 'profile'
        },
        searchResults: {
            path: 'search-results'
        },
        leads: {
            path: 'leads',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        }
                    }
                }
            }
        },
        verifications: {
            path: 'verifications',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        }
                    }
                }
            }
        },
        clients: {
            path: 'clients',
            children: {
                add: {
                    path: 'add',
                    children: {
                        individual: {
                            path: 'individual'
                        },
                        corporate: {
                            path: 'corporate'
                        }
                    }
                },
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        assessment: {
                            path: 'assessment'
                        },
                        amlRisk: {
                            path: 'aml-risk'
                        },
                        documents: {
                            path: 'documents'
                        },
                        paymentAccounts: {
                            path: 'payment-accounts',
                            children: {
                                bankAccounts: {
                                    path: 'bank'
                                },
                                cryptoWallets: {
                                    path: 'crypto'
                                },
                                cryptoDepositAddress: {
                                    path: 'crypto-deposit-address'
                                },
                            }
                        },
                        payments: {
                            path: 'payments'
                        },
                        accounts: {
                            path: 'accounts'
                        },
                        marketData: {
                            path: 'market-data-feeds'
                        },
                        marketDataMarkup: {
                            path: 'market-data-markup'
                        },
                        notes: {
                            path: 'notes'
                        },
                        activities: {
                            path: 'activities'
                        },
                        users: {
                            path: 'users'
                        },
                        accessRights: {
                          path: 'access-rights'
                        },
                        twoFactor: {
                            path: '2fa'
                        },
                        referral: {
                            path: 'referral-program'
                        }
                    }
                }
            }
        },
        clientUsers: {
            path: 'client-users',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        marketData: {
                            path: 'market-data-feed'
                        },
                        marketDataMarkup: {
                            path: 'market-data-feed-markup'
                        },
                        accessRights: {
                            path: 'access-rights'
                        },
                        twoFactor: {
                            path: '2fa'
                        },
                    }
                }
            }
        },
        documents: {
            path: 'documents',
            children: {
                edit: {
                    path: 'edit'
                },
                publicProfilePicture: {
                    path: 'public-profile-picture'
                }
            }
        },
        bankAccounts: {
            path: 'bank-accounts',
            children: {
                edit: {
                    path: 'edit',
                }
            }
        },
        messages: {
            path: 'panel-messages',
            children: {
                add: {
                    path: 'add',
                },
                detail: {
                    path: 'detail',
                },
                edit: {
                    path: 'edit',
                }
            }
        },
        payments: {
            path: 'payments',
            children: {
                edit: {
                    path: 'edit'
                }
            }
        },
        referralPayouts: {
            path: 'referral-withdrawals',
            children: {
                edit: {
                    path: ''
                }
            }
        },
        accounts: {
            path: 'accounts',
            children: {
                use: {
                    path: 'use'
                },
                add: {
                    path: 'add',
                    children: {
                        cashAccount: {
                            path: 'cash'
                        },
                        tradingAccount: {
                            path: 'trading'
                        },
                        tradingAccountMapping: {
                            path: 'mapping'
                        },
                        tradingAccountRights: {
                            path: 'rights'
                        },
                        onboarding: {
                            path: 'onboarding'
                        }
                    }
                },
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        subscriptions: {
                            path: 'subscriptions'
                        },
                        riskSettings: {
                            path: 'risk-settings'
                        },
                        feePlans: {
                            path: 'fee-plans'
                        },
                        currentPosition: {
                            path: 'current-position'
                        },
                        orderRoutes: {
                            path: 'order-routes'
                        },
                        users: {
                            path: 'users'
                        },
                        plans: {
                            path: 'plans',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                stats: {
                                    path: 'stats'
                                },
                                trades: {
                                    path: 'trades'
                                }
                            }
                        },
                        publicPortfolio: {
                            path: 'public-portfolio'
                        },
                    }
                }
            }
        },
        couponBonds: {
            path: 'coupon-bonds',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        allocation: {
                            path: 'allocation'
                        },
                        payments: {
                            path: 'payments'
                        }
                    }
                }
            }
        },
        orders: {
            path: 'orders',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        }
                    }
                }
            }
        },
        platformFrontends: {
            path: 'panel-platform-frontends',
        },
        exchange: {
            path: 'panel-exchanges',
        },
        reports: {
            path: 'reports',
            children: {
                accountReports: {
                    path: 'accounts'
                },
                executionsReports: {
                    path: 'executions',
                    children: {
                        equities: {
                            path: "equities"
                        },
                        fx: {
                            path: "fx"
                        },
                    }
                },
                groupReports: {
                    path: 'groups'
                },
                referralReports: {
                    path: 'referrals'
                },
                referralCommissions: {
                    path: 'referral-commissions'
                },
                referralPayoutsReport: {
                    path: 'referral-payouts'
                },
                marketing: {
                    path: 'marketing'
                },
                campaignReports: {
                    path: 'campaigns',
                    children: {
                        manage: {
                            path: 'manage'
                        }
                    }
                }
            }
        },
        bulkPayments: {
            path: 'bulk-payments',
        },
        AMLRiskMatrix: {
            path: 'aml-risk-matrix'
        },
        alerts: {
            path: 'alerts'
        },
        marketData: {
            path: 'market-data',
            children: {
                feeds: {
                    path: 'feeds',
                    children: {
                        edit: {
                            path: 'edit',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                priceHistory: {
                                    path: 'price-history'
                                }
                            }
                        },
                        editBundle: {
                            path: 'edit-bundle',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                priceHistory: {
                                    path: 'price-history'
                                }
                            }
                        }
                    }
                },
                serviceUsers: {
                    path: 'service-users',
                    children: {
                        edit: {
                            path: 'edit',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                marketData: {
                                    path: 'market-data-feed'
                                },
                            }
                        }
                    }
                },
                entitlementReports: {
                    path: 'entitlement-reports'
                },
                eventHistory: {
                    path: 'event-history'
                },
                usageReports: {
                    path: 'usage-reports'
                },
                marketDataReports: {
                    path: 'market-data-reports'
                }
            }
        },
        settings: {
            path: 'settings',
            children: {
                messages: {
                    path: 'messages',
                    children: {
                        messageTemplates: {
                            path: 'message-templates',
                            children: {
                                add: {
                                    path: 'add'
                                },
                                edit: {
                                    path: 'edit'
                                },
                                view: {
                                    path: 'view'
                                }
                            }
                        },
                        emailTemplates: {
                            path: 'email-templates',
                            children: {
                                add: {
                                    path: 'add'
                                },
                                edit: {
                                    path: 'edit'
                                },
                                view: {
                                    path: 'view'
                                }
                            }
                        },
                        textPlaceholders: {
                            path: 'text-placeholders',
                            children: {
                                add: {
                                    path: 'add'
                                },
                                edit: {
                                    path: 'edit'
                                },
                                view: {
                                    path: 'view'
                                }
                            }
                        },
                    }
                },
                groups: {
                    path: 'groups',
                    children: {
                        add: {
                            path: 'add'
                        },
                        edit: {
                            path: 'edit',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                accounts: {
                                    path: 'accounts'
                                },
                                orderRoutes: {
                                    path: 'order-routes'
                                },
                                riskSettings: {
                                    path: 'risk-settings'
                                }
                            }
                        },
                        view: {
                            path: 'view',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                accounts: {
                                    path: 'accounts'
                                }
                            }
                        }
                    }
                },
                cashAccounts: {
                    path: 'cash-accounts',
                    children: {
                        add: {
                            path: 'add'
                        }
                    }
                },
                legalDeclarations: {
                    path: 'legal-declarations'
                },
                tradingAccounts: {
                    path: 'trading-accounts',
                    children: {
                        add: {
                            path: 'add'
                        }
                    }
                },
                roles: {
                    path: 'roles',
                    children: {
                        add: {
                            path: 'add'
                        },
                        edit: {
                            path: 'edit'
                        }
                    }
                },
                operators: {
                    path: 'operators',
                    children: {
                        add: {
                            path: 'add'
                        },
                        view: {
                            path: 'preview'
                        },
                        edit: {
                            path: 'edit'
                        }
                    }
                },
                products: {
                    path: 'products',
                    children: {
                        edit: {
                            path: 'edit',
                            children: {
                                details: {
                                    path: 'details'
                                },
                                prices: {
                                    path: 'prices'
                                },
                                couponPayments: {
                                    path: 'coupon-payments'
                                },
                                documents: {
                                    path: 'documents'
                                },
                                notifications: {
                                    path: 'notification-receivers'
                                }
                            }
                        }
                    }
                },
                closeoutPlans: {
                    path: 'closeout-plans',
                    children: {
                        plans: {
                            path: 'plans',
                            children: {
                                edit: {
                                    path: 'edit',
                                    children: {
                                        details: {
                                            path: 'details'
                                        },
                                        accounts: {
                                            path: 'accounts'
                                        }
                                    }
                                }
                            }
                        },
                        assignmentRules: {
                            path: 'assignment-rules'
                        }
                    }
                },
                audit: {
                    path: 'audit'
                },
                fileImport: {
                    path: 'file-import'
                }
            }
        },
        plans: {
            path: 'plans',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        characteristics: {
                            path: 'characteristics'
                        },
                        users: {
                            path: 'users'
                        }
                    }
                }
            }
        },
        coupons: {
            path: 'coupons',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        redemptions: {
                            path: 'redemptions'
                        }
                    }
                }
            }
        },
        orderRoutes: {
            path: 'order-routes',
            children: {
                edit: {
                    path: 'edit',
                    children: {
                        details: {
                            path: 'details'
                        },
                        routes: {
                            path: 'routes'
                        },
                        routeSets: {
                            path: 'routeSets'
                        }
                    }
                }
            }
        },
    }
};
